import { Reveal, Overline } from "@/components/site/Reveal";
import { FloatingDecor } from "@/components/site/FloatingDecor";
import { IMAGES } from "@/lib/site";
import { useLang } from "@/context/LanguageContext";

export const FeatureMoment = () => {
  const { t } = useLang();
  return (
    <section data-testid="feature-moment" className="relative bg-[#F8F9FA] py-24 md:py-32 overflow-hidden">
      <FloatingDecor />
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-14 items-center">
          <div className="md:col-span-7 order-2 md:order-1">
            <Reveal>
              <div className="relative">
                <div className="relative overflow-hidden aspect-[16/11]">
                  <img
                    data-testid="feature-image"
                    src={IMAGES.president}
                    alt="President Herbert Joseph delivering his speech at the Marriott Hotel, Haiti"
                    className="w-full h-full object-cover object-[50%_20%]"
                  />
                  <div className="absolute inset-0 ring-1 ring-inset ring-[#D4AF37]/40" />
                  <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-[#0A1128]/85 to-transparent" />
                  <p className="absolute bottom-5 left-5 right-5 text-white/90 text-sm md:text-base font-medium">
                    {t("feature.caption")}
                  </p>
                </div>
                <div className="absolute -top-5 -left-5 w-24 h-24 border-t border-l border-[#D4AF37]" />
                <div className="absolute -bottom-5 -right-5 w-24 h-24 border-b border-r border-[#D4AF37]" />
              </div>
            </Reveal>
          </div>

          <div className="md:col-span-5 order-1 md:order-2">
            <Reveal delay={0.1}>
              <Overline>{t("feature.overline")}</Overline>
              <h2 className="mt-6 font-display text-3xl md:text-5xl leading-[1.05] tracking-tight text-[#0A1128]">
                {t("feature.title")}
              </h2>
              <p className="mt-6 text-base md:text-lg text-[#4B5563] leading-relaxed">{t("feature.body")}</p>
              <div className="mt-8 flex items-center gap-4">
                <span className="w-12 gold-rule" />
                <span className="text-sm text-[#B8901F] uppercase tracking-[0.15em]">Marriott Hotel · Haiti</span>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
